
import './i18n';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useSelector } from "react-redux"
import { Navigate, Outlet } from "react-router-dom"
import AffiliatesDashboard from './pages/dashboard';
import AffiliateSignin from './pages/signin';
import AffiliateSignup from './pages/signup';
import TermsAndCondition from './pages/help/TermsAndCondition';
import PrivacyPolicy from './pages/help/PrivacyPolicy';
import CookiePolicy from './pages/help/CookiePolicy';
import { Provider } from 'react-redux';
import store from './store';
import {useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { Helmet } from 'react-helmet';

// **** Main CSS **** //
import './assets/scss/main.scss';
import VerifyEmail from './pages/signup/VerifyEmail';
import { getCountries } from './services/affiliateApi';
import { COUNTRY_CODE } from './utils/localstore';
import ForgotPassword from './pages/forgot-password/ForgotPassword';
import ResetPassword from './pages/reset-password/ResetPassword';
import TwoFactorAuthentication from './pages/two-factor-authentication';
import applySCSSTheme from './utils/applySCSSTheme';
import useFavicon from './hooks/useFavicon';

function Navigation() {
  const { afIsAuthenticated } = useSelector(state => state.afAuth);
  const appName = process.env.REACT_APP_NAME;
  let favicon = '/default-favicon.ico';
  let meta = {
    title: 'data2go - Affiliate',
    description: 'data2go The Smart Travellers\' Choice - Stay connected across borders, without breaking the bank',
    ogImage: 'https://data2go.mobi/data2go-icon.png',
  };

  if (appName === 'esimcrew') {
    favicon = '/esimcrew-favicon.ico';
    meta = {
      title: 'eSIMCrew - Affiliate',
      description: 'eSIMCrew',
    };
   
  } else if (appName === 'esimple') {
    favicon = '/esimple-favicon.ico';
    meta = {
      title: 'eSimple - Affiliate',
      description: 'eSimple',
    };

  } else if (appName === 'esimlinks') {
    favicon = '/esimlinks-favicon.ico';
    meta = {
      title: 'eSIMLinks - Affiliate',
      description: 'eSIMLinks: CONNECT WORLDWIDE',
    };

  } else if (appName === 'gopamwe') {
    favicon = '/gopamwe-favicon.ico';
    meta = {
      title: 'GO PAMWE - Affiliate',
      description: 'GO PAMWE: Connecting You',
    };

  } else if (appName === 'awesim') {
    favicon = '/awesim-favicon.ico';
    meta = {
      title: 'awesim - Affiliate',
      description: 'awesim',
       favicon:"/brandicon/favicon_awesim"
    };
  } else if (appName === 'data2go-corporate') {
    favicon = '/default-favicon.ico';
    meta = {
      title: 'data2go - Corporate',
      description: 'data2go Corporate',
    };
  } else if (appName === 'gopamwe-corporate') {
    favicon = '/gopamwe-favicon.ico';
    meta = {
      title: 'Gopamwe - Corporate',
      description: 'Gopamwe Corporate',
    };
  } else if (appName === 'pinoy') {
    favicon = '/pinoy-favicon.ico';
    meta = {
      title: 'Pinoy eSIM - Affiliate',
      description: 'Pinoy eSIM - Affiliate',
    };
  } else if (appName === 'pinoy-corporate') {
    favicon = '/pinoy-favicon.ico';
    meta = {
      title: 'Pinoy eSIM - Corporate',
      description: 'Pinoy eSIM Corporate',
    };
  }
   else if (appName === 'orzo') {
    favicon = '/orzo-favicon.ico';
    meta = {
      title: 'Orzo Travel - Affiliate',
      description: 'Orzo Travel - Affiliate',
    };
  } else if (appName === 'orzo-corporate') {
    favicon = '/orzo-favicon.ico';
    meta = {
      title: 'Orzo Travel - Corporate',
      description: 'Orzo Travel Corporate',
    };
  }


  useFavicon(favicon);

  useQuery({
    enabled: !localStorage.getItem(COUNTRY_CODE),
    queryFn: getCountries,
    queryKey: ['GETAVAILBLECOUNTRY'],
    onSuccess: o => localStorage.setItem(COUNTRY_CODE,o?.ipcountry)
});


  return (
    <>
        <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
    <Router>
      <Routes>
        {/* Affiliate Public Route */}
        <Route element={afIsAuthenticated ? <Navigate to='/affiliates-dashboard' /> : <Outlet />} >
        <Route path='/' element={ <AffiliateSignin />} />
          <Route path='/affiliate-signup' element={ <AffiliateSignup />} />
          <Route path='/verify-email' element={<VerifyEmail />} />  
            <Route path='/forgot-password' element={ <ForgotPassword />} />   
            <Route path='/reset-password' element={ <ResetPassword />} />   
            <Route path='/two-factor-authentication' element={ <TwoFactorAuthentication />} />   
        </Route>

        {/* Affiliate Private Route */}
        <Route element={afIsAuthenticated ?  <Outlet /> : <Navigate to='/affiliate-signin' />} >
            <Route path='/affiliates-dashboard' element={ <AffiliatesDashboard />} />
        </Route>
        <Route path='*' element={<Navigate to='/' />} />
        <Route path='/terms-and-conditions' element={ <TermsAndCondition />} />        
            <Route path='/privacy-policy' element={ <PrivacyPolicy />} />    
            <Route path='/cookie-policy' element={ <CookiePolicy />} /> 
        
      </Routes>
    </Router>
    </>
  );
}

export default function App(){

  applySCSSTheme()

  const queryClient = new QueryClient();

  return <Provider store={store} >
    <QueryClientProvider client={queryClient}>
      <Navigation/>
    </QueryClientProvider>
  </Provider>
};
